<template>
   <svg xmlns="http://www.w3.org/2000/svg" width="30" height="10" viewBox="0 0 643 650">
  <path id="Ntchito_Icon_1" data-name="Ntchito Icon 1" class="cls-1" d="M426.084,258.694a333.47,333.47,0,0,0-90.155,77.573,178.23,178.23,0,0,1,45.983-18.725,173.563,173.563,0,0,1,49.105-5.35,149.935,149.935,0,0,1,46.429,8.917,127.3,127.3,0,0,1,37.944,21.4q32.147-10.7,71.427-10.7,83.92,0,144.639,60.506,58.921,61.4,58.929,149.477,0,88.106-58.985,149.477-59,60.52-142.116,60.506-74.179,0-131.374-47.257-69.728-56.174-73.294-148.9-1.8-43.677,13.46-70.441t37.693-37.449a71.458,71.458,0,0,1,47.126-5.35q24.663,5.351,41.733,25.858,8.9-35.652-.446-61.97-9.363-26.289-30.767-41.461-21.4-15.151-50.387-20.062A151.867,151.867,0,0,0,330.216,370.15a121.145,121.145,0,0,0-40.131,46.365,146.808,146.808,0,0,0-11.594,28.979,272.444,272.444,0,0,0-7.134,32.545q-2.676,16.949-4.013,32.545t-1.338,28.979q0,133.747,91.856,229.154,91.84,96.3,231.868,96.3,132.87,0,226.517-93.623,92.741-92.726,92.747-229.154,0-137.3-94.614-231.829Q720.657,215.011,588.545,215q-86.595,0-162.461,43.691h0Z" transform="translate(-266 -215)"/>
</svg>
</template>
<script>
export default {
    
}
</script>
<style scoped>
     .cls-1{
        fill: var(--footer-text);
      }
</style>